import Logo from './Logo'
import logoContainer from './logoContainer'

export default logoContainer(Logo)
